module.exports = __webpack_public_path__ + "img/icon_trash.33e5dfb5.svg";